import React, { Component } from "react";
import "./SamplePassport.scss";
import VoterIDFront from "../../../assets/docSampleImages/Passport Front.jpg";
import VoterIDBack from "../../../assets/docSampleImages/Passport Back.jpg";
import BottomPanel from "../../BottomPanel/BottomPanel";
export interface ISamplePassportMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}
const SamplePassportMobileViewProps = (
  props: ISamplePassportMobileViewProps
) => {
  const getMobileUIPopup = () => {
    return (
      <div className="mobile-view">
        <span className="mobile-view-text">Uploading Passport</span>
        <div className="Aadhar-format-2">
          <span>
            <p className="Aadhar-format-read-more">
              Attach a readable front & back photo of your Passport in JPEG or
              PNG (Max Size: 2MB)
            </p>
            <span className="passport-row">
              <span className="Aadhar-Front-row">
                <div className="image-container">
                  <img
                    src={VoterIDFront}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image" alt="Sample passport front" />
                  <div className="badge">1</div>
                </div>

                <span className="Aadhar-Label">FRONT</span>
              </span>
              <span className="Aadhar-Front-row mgl-20">
                <div className="image-container">
                  <img
                    src={VoterIDBack}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image" alt="Sample passport back" />
                  <div className="badge">2</div>
                </div>

                <span className="Aadhar-Label">BACK</span>
              </span>
            </span>
          </span>
        </div>
      </div>
    );
  };
  return (
    <BottomPanel
      customComponent={getMobileUIPopup}
      setShowSection={props?.setShowPopup}
    />
  );
};
export default SamplePassportMobileViewProps;
